import { create } from "zustand";

export interface IPrivacyStore {
    openPrivacyModal: boolean;
    setOpenPrivacyModal: (value: boolean) => void;
    openPrivacyNoticeModal: boolean;
    setOpenPrivacyNoticeModal: (value: boolean) => void;
    openTermsAndConditionModal: boolean;
    setOpenTermsAndConditionModal: (value: boolean) => void;
}

const usePrivacyStore = create<IPrivacyStore>((set) => ({
    openPrivacyModal: false,
    setOpenPrivacyModal: (value) => set({ openPrivacyModal: value }),
    openPrivacyNoticeModal: false,
    setOpenPrivacyNoticeModal: (value) => set({openPrivacyNoticeModal: value}),
    openTermsAndConditionModal: false,
    setOpenTermsAndConditionModal: (value) => set({openTermsAndConditionModal: value})
}));

export default usePrivacyStore;